import React from "react";
import SEO, { buildLocalBusinessJsonLd } from "@/components/SEO";
import CTASection from "@/components/CTASection";
import HomeHero from "@/components/home/HomeHero";
import HomeServicesOverview from "@/components/home/HomeServicesOverview";
import HomeMaintenanceHighlight from "@/components/home/HomeMaintenanceHighlight";
import HomeRoofingBlock from "@/components/home/HomeRoofingBlock";
import HomeRemodelingBlock from "@/components/home/HomeRemodelingBlock";
import HomePopularServices from "@/components/home/HomePopularServices";
import HomeWhySection from "@/components/home/HomeWhySection";
import HomeProcessSection from "@/components/home/HomeProcessSection";
import HomeTestimonials from "@/components/home/HomeTestimonials";
import HomeServiceAreas from "@/components/home/HomeServiceAreas";
import HomeSubcontractorCTA from "@/components/home/HomeSubcontractorCTA";
import HomeFAQSection from "@/components/home/HomeFAQSection";

export default function Home() {
  return (
    <>
      <SEO
        title="Austin TX General Contractor, Roofing & Maintenance | Black Ridge Construction"
        description="Black Ridge Construction is a full-service Austin general contractor. Roofing, remodeling, additions, repairs, outdoor living, and ongoing home maintenance memberships."
        jsonLd={buildLocalBusinessJsonLd()}
      />
      <HomeHero />
      <HomeServicesOverview />
      <HomeMaintenanceHighlight />
      <HomeRoofingBlock />
      <HomeRemodelingBlock />
      <HomePopularServices />
      <HomeWhySection />
      <HomeProcessSection />
      <HomeTestimonials />
      <HomeServiceAreas />
      <HomeSubcontractorCTA />
      <HomeFAQSection />
      <CTASection />
    </>
  );
}
